import { get } from '@tovala/browser-apis-cdn'

import { APP_ID } from 'utils/api'

import {
  GetMealRatingSummaryRequest,
  GetMealRatingSummaryResponse,
} from '../combinedapi/mealRatingSummary'

export const ENDPOINTS = {
  GET_MEAL_RATING_SUMMARY: ({
    mealID,
  }: Pick<GetMealRatingSummaryRequest, 'mealID'>) => ({
    path: `/v2/meals/${mealID}/ratingSummary`,
  }),
}

export async function getMealRatingSummaryFromCDN({
  mealID,
}: GetMealRatingSummaryRequest) {
  return get<GetMealRatingSummaryResponse>({
    ...ENDPOINTS.GET_MEAL_RATING_SUMMARY({ mealID }),
    config: { headers: { 'X-Tovala-AppID': APP_ID } },
  })
}
